export default "__VITE_ASSET__C3T01sVh__"